import { Box, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { addPatientExternalReferralsServicesFinanceHistory } from "../../api/group";
import { InputCreateProject } from "../../components/project/createProjectPop";
import DatePicker from "../../components/project/datePicker";

export default function DataMaliForm({
  areaId,
  patientId,
  formId,
  dataService,
}) {
  const [showDatePicker, setShowDatePicker] = useState();
  const [date, setDate] = useState();
  const [data, setData] = useState({
    action: "",
    cardNo: "",
    amount: 0,
    date: "",
  });
  useEffect(() => {
    if (dataService?.payments?.length > 0) {
      setData(dataService?.payments[dataService?.payments?.length - 1]);
    }
  }, [dataService]);

  useEffect(() => {
    if (date) {
      setData({
        ...data,
        date: date.toUnix(),
      });
    }
  }, [date]);

  // console.log(data);

  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
        notRange
      />
      <Box bgcolor="#EFF1F7">
        <Typography color="#126E83" p="20px 10px" fontWeight={"bold"}>
          {"پرونده مالی مریض"}
        </Typography>
        <Box p="10px" display="flex" gap="1vw" flexWrap={"wrap"}>
          <InputCreateProject
            placeholder={"هزینه کل را به عدد وارد نمایید"}
            label="مبلغ واریزی"
            width={"14vw"}
            onChange={(e) =>
              setData({ ...data, amount: Number(e.target.value) })
            }
            value={data?.amount || ""}
          />
          <InputCreateProject
            placeholder={"کارت مقصد را وارد نمایید"}
            label="کارت مقصد"
            width={"14vw"}
            onChange={(e) => setData({ ...data, cardNo: e.target.value })}
            value={data?.cardNo || ""}
          />
          <InputCreateProject
            placeholder={"چیزی بنویسید"}
            label="اقدامات"
            width={"14vw"}
            onChange={(e) => setData({ ...data, action: e.target.value })}
            value={data?.action || ""}
          />
          <InputCreateProject
            placeholder={"تاریخ را انتخاب کنید"}
            label="تاریخ"
            width={"14vw"}
            onClick={(e) => {
              setShowDatePicker(e.currentTarget);
            }}
            value={
              date ? `${date.year}/${date.month}/${date.day} ` : data?.date.split("T",2)[0]
            }
            // value={data?.date || ""}
          />
          <Box display="flex" justifyContent={"end"} p="10px 30px">
            <Box
              width={"fit-content"}
              p="7px 30px"
              borderRadius={"9px"}
              color="white"
              bgcolor="var(--emr-darkblue)"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                addPatientExternalReferralsServicesFinanceHistory(
                  areaId,
                  patientId,
                  formId,
                  dataService?.id,
                  data
                )
                  .then(() => {
                    toast.success("ثبت شد");
                  })
                  .catch(() => {})
              }
            >
              {"ثبت"}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
